<style scoped>
.ipt-sty {
  width: 70% !important;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
/deep/ .el-table__expand-icon {
    display: none; 
}
.tab-box{
  display: flex;
  margin-bottom: 25px;
}
.tab-box-list {
  color: #4D4D4D;
  font-size: 16px;
  margin: 0 13px;
  cursor: pointer;
  position: relative;
}
.tab-box-active {
  color: #232323;
}
.tab-box-active .tab-box-line {
  width: 80%;
  height: 3px;
  background: #4fa1a4;
  margin-top: 4px;
  position: absolute;
  left: 10%;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">药企名称</div>
          <el-select
            size="mini"
            v-model="page.tenantGuid"
            placeholder="请选择药企名称"
            class="ipt-sty w70f"
            @change="tenantChange"
            clearable
            filterable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称</div>
          <el-select
            size="mini"
            v-model="page.organisationGuid"
            placeholder="请选择部门名称"
            class="ipt-sty w70f"
            clearable
            filterable
            multiple 
            collapse-tags
            @focus="getOrganisation()"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">离职人员</div>
          <el-input size="mini" v-model="page.staffName" class="ipt-sty w70f" placeholder="请输入姓名/手机号" clearable></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">离职时间</div>
          <el-date-picker
            size="mini"
            v-model="timeLists"
            class="ipt-sty w70f"
            type="daterange"
            range-separator="至"
            clearable
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="height:100%">
      <div class="tab-box" style="padding-top: 16px;">
        <div
            v-for="(item, index) in tabText"
            :key="index"
            :class="activeTab == index ? 'tab-box-list tab-box-active' : 'tab-box-list'"
            @click="changeTab(index, item)"
        >
            <div>{{ item.name }}</div>
            <div class="tab-box-line"></div>
        </div>
      </div>
      <el-table ref="table" :data="tableData.slice((page.pageIndex - 1) * page.pageSize,page.pageIndex * page.pageSize)" :height="tableHeight" stripe border style="width: 100%;" v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="离职人员" show-overflow-tooltip header-align="left" align="left"></el-table-column>
        <el-table-column prop="tenantName" label="所属药企" show-overflow-tooltip header-align="left" align="left"></el-table-column>
        <el-table-column prop="sendTenantName" label="所属部门" show-overflow-tooltip header-align="left" align="left">
          <template slot-scope="scope">
            {{scope.row.organisationNames?scope.row.organisationNames.toString():'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="dimissionDate" width="120px" label="离职时间" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.dimissionDate | getDate }}</template>
        </el-table-column>
        <el-table-column v-if="page.allocateState == 2" prop="replaceStaffName" label="接替人员" show-overflow-tooltip header-align="left" align="left"></el-table-column>
        <el-table-column width="120px"  :prop="page.allocateState == 1?'customerTotal':'allocateCustomerNum'" :label="page.allocateState == 1?'待分配客户数':'已分配客户数'" show-overflow-tooltip header-align="right" align="right"></el-table-column>
        <el-table-column width="120px" :prop="page.allocateState == 1?'taskTotal':'allocateTaskNum'" :label="page.allocateState == 1?'待分配任务数':'已分配任务数'" show-overflow-tooltip header-align="right" align="right"></el-table-column>
        <!-- <el-table-column width="110px" v-if="page.allocateState == 2" prop="allocateCustomerNum" label="已分配客户数" show-overflow-tooltip header-align="right" align="right"></el-table-column>
        <el-table-column width="110px" v-if="page.allocateState == 2" prop="allocateTaskNum" label="已分配任务数" show-overflow-tooltip header-align="right" align="right"></el-table-column> -->
        <el-table-column width="100px" prop="dimissionDate" v-if="page.allocateState == 2" label="分配时间" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column width="90px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="toDetail(scope.row)">{{page.allocateState == 1?'离职继承':'查看详情'}}</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 50,100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 280,
      contentMainHeight: window.innerHeight - 157,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        leaveStartDate:null,
        leaveEndDate:null,
        tenantGuid: null,
        organisationGuid: [],
        staffName: null,
        allocateState: 1,
      },
      timeLists: [],
      organisationList: [],
      tenantList: [],
      loading:false,
      tableData: [],
      tabText: [
        { name: '待分配', value: '1' },
        { name: '已分配', value: '2' },
      ],
      activeTab:0
    };
  },
  watch: {
    showMore(val, oldVal) {
      if(val) {
        this.tableHeight = window.innerHeight - 320;
        return;
      }
      if(!val) {
        this.tableHeight = window.innerHeight - 280;
        return;
      }
    },
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenantList();
  },
  methods: {
    //获取药企
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange(val){
      if(val){
        this.getOrganisationList(val)
      }
    },
    //获取组织
    getOrganisationList(tenantGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid,
      };
      self.page.organisationGuid = [];
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation() {
      if (this.page.tenantGuid == '' || this.page.tenantGuid == null) {
        this.$message.error('请选择药企名称!');
        return;
      }
    },
    changeTab(index, item) {
      this.page.allocateState = item.value;
      this.activeTab = index;
      this.getData(1);
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        leaveStartDate:null,
        leaveEndDate:null,
        tenantGuid: null,
        organisationGuid: [],
        staffName: null,
        allocateState: 1,
      };
      this.activeTab = 0;
      this.timeLists = [];
      self.getData(true);
    },
    //对数据进行日期排序
    sortDataArray(dataArray) {
      const self = this;
      return dataArray.sort((a, b) => {
        console.log(self.$moment(b.dimissionDate).unix())
        return self.$moment(b.dimissionDate).unix() - self.$moment(a.dimissionDate).unix();
      });
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(this.timeLists.length>0){
        self.page.leaveStartDate = this.timeLists[0];
        self.page.leaveEndDate = this.timeLists[1];
      }
      self.api.postJson(`/${serverConfig.msUserRemunerationService}/duty-transform/list`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;  
          if(res.data.data.records){
            self.tableData = self.sortDataArray(res.data.data.records)
          }else{
            self.tableData = []
          }
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.$nextTick(() => {
            self.$refs.table.doLayout();//解决固定列错位
          });
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    toDetail(row){
      localStorage.removeItem('leaveStaffData')
      this.$router.push(
        {
          path:'/resignationInheritanceDetail',
          // query:{
          //   row:JSON.stringify(row)
          // }
        }
      )
      row.allocateState = this.page.allocateState;
      localStorage.setItem('leaveStaffData',JSON.stringify(row))
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

  
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
